module.exports = require("./ii.d.ts");